import { ESIInclude } from "@/components/__shared__/ESIInclude/ESIInclude";
import { Breadcrumbs } from "@/components/Breadcrumbs/Breadcrumbs";
import { PageType } from "@/types/types";
import { TitleText } from "@/components/__shared__/TitleText/TitleText";
import styles from "./NoResults.module.scss";
import { ProductListingResponse } from "@/types/productListing";
import { useRouteParams } from "@/hooks/useRouteParams";
import { PageProps } from "@/getServerSideProps/getServerSideProps";
import { Footer, Header } from "@/components";

export default function NoResults({
  productListingData,
}: Pick<PageProps, "productListingData">) {
  const route = useRouteParams();
  const { "search-term": searchTerm } = route.query;

  const { heading, subHeading } = getHeading(
    route.pageType,
    productListingData.pageInformation,
    Array.isArray(searchTerm) ? searchTerm[0] : searchTerm,
  );

  return (
    <>
      <Header />
      <main className={styles.main}>
        <Breadcrumbs productListingData={productListingData} />
        <TitleText heading={heading} subHeading={subHeading} />
        <p className={styles.subCopy} data-testid="no-results-subcopy">
          It might be temporarily out of stock. Try a more generic search term
          or try looking for alternative products within the departments.
        </p>
        <ESIInclude
          src="/content-renderer/no-results?includeCoreCss=false&includeCoreJS=false&includePolyfills=false"
          id="plp-no-results"
        />
      </main>
      <Footer />
    </>
  );
}

function getHeading(
  pageType: PageType,
  pageInformation: ProductListingResponse["pageInformation"],
  searchTerm?: string,
): {
  heading: string;
  subHeading?: string;
} {
  if (pageType !== "search") {
    const heading =
      pageInformation.heading ||
      "Sorry, something went wrong, please try searching again.";

    return {
      heading,
      subHeading: pageInformation.subHeading,
    };
  }

  const heading = !searchTerm
    ? "Sorry, something went wrong, please try searching again."
    : `Sorry, we couldn't find any results for ‘${searchTerm}’`;

  return {
    heading,
  };
}
